export * from './department-form.service';
export * from './department.service';
export * from './department.model';
export * from './person.model';


// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/departments/shared/index.ts